import type { ReactNode } from 'react';
import { NavigationType, UNSAFE_LocationContext, useLocation, useNavigationType } from 'react-router-dom';

/**
 * L'emplacement que lisent les ecrans de la bande.
 *
 * `Routes` sait lire une autre adresse que celle qui a cours, mais il enveloppe alors son
 * contenu dans un contexte de plus, et seulement dans ce cas (`useRoutes`). Ouvrir un
 * ecran par-dessus changeait donc la forme de l'arbre, et React demontait l'ecran qu'on
 * voulait justement garder : la carte se reconstruisait au retour. Il annonce aussi la
 * navigation comme un retour, ce qui retirait l'animation d'entree des sous-ecrans.
 *
 * Le contexte est donc pose ici, toujours : la forme ne change plus, et la navigation
 * reste celle qui a eu lieu.
 *
 * @param fond L'adresse de l'ecran du dessous, quand un autre s'ouvre par-dessus.
 * @param location Celle d'un ecran qu'on montre sans y etre : voir `TabSwipe`.
 */
export function Ecrans({
  fond,
  location,
  children,
}: {
  fond: ReturnType<typeof useLocation> | null;
  location?: ReturnType<typeof useLocation>;
  children: ReactNode;
}) {
  const ici = useLocation();
  const navigation = useNavigationType();
  return (
    <UNSAFE_LocationContext.Provider
      value={{
        location: location ?? fond ?? ici,
        navigationType: location ? NavigationType.Pop : navigation,
      }}
    >
      {children}
    </UNSAFE_LocationContext.Provider>
  );
}
